// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getSrcFromImport(content: any) {
  return typeof content?.src === 'string' ? content.src : content
}
